import styled from '@emotion/styled'
import InvitationDialogCopy from './InvitationDialogCopy'

const InvitationCenteredCopy = styled(InvitationDialogCopy)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: '1.5rem 0 .5rem',
  justifyContent: 'center'
})

export default InvitationCenteredCopy
